import * as React from 'react';
import * as dayjs from 'dayjs';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { DatePickerDialogContent } from './components/DatePickerDialogContent';
import Dialog from '@mui/material/Dialog';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';

function PaperComponent(props) {
  return (
    <Draggable cancel={'[class*="MuiDialogContent-root"]'} handle="#draggable-dialog-box">
      <Paper {...props} />
    </Draggable>
  );
}

const style = {
  cursor: 'move',
  bgcolor: 'background.paper',
  width: 'fit-content',
  border: '1px solid rgba(155,149,159,0.26)',
  boxShadow: 20,
  borderRadius: 1,
  p: 4
};

function DatePicker({ isOpen, setIsOpen, handleValueChange }) {
  const handleSelectionChange = React.useCallback(
    (selection) => {
      if (dayjs(selection.startDate).isSame(selection.endDate)) {
        handleValueChange({
          singleDate: dayjs(selection.startDate).format('YYYY-MM-DD').replaceAll('-', '/')
        });

        return;
      }

      const newSelection = {
        ...selection
      };
      if (newSelection.startDate) {
        newSelection.startDate = dayjs(newSelection.startDate)
          .format('YYYY-MM-DD')
          .replaceAll('-', '/');
      }
      if (newSelection.endDate) {
        newSelection.endDate = dayjs(newSelection.endDate)
          .format('YYYY-MM-DD')
          .replaceAll('-', '/');
      }

      handleValueChange(newSelection);
    },
    [handleValueChange]
  );

  const handleClose = React.useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return (
    <Box>
      <Dialog
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        onClose={handleClose}
        open={isOpen}
        overlayStyle={{ backgroundColor: 'transparent' }}
        sx={{
          '.MuiBox-root': {
            padding: '0 0 10px'
          }
        }}
      >
        <Box id="draggable-dialog-box" sx={{ ...style }}>
          <DatePickerDialogContent handleSelectionRange={handleSelectionChange} />
        </Box>
      </Dialog>
    </Box>
  );
}

DatePicker.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  handleValueChange: PropTypes.func.isRequired
};

export { DatePicker };
